import type { ChipProps } from "@mui/material";
import { LABEL_PATTERNS } from "./Tag.constants";

/**
 * Resolves chip label: first matching LABEL_PATTERN, else family:name bold, else plain.
 */
export const resolveTagLabel = (tag: string): ChipProps["label"] => {
  for (const pattern of LABEL_PATTERNS) {
    if (pattern.test(tag)) {
      return pattern.render(tag);
    }
  }

  const tagParts = tag.split(":");
  if (tagParts.length === 2) {
    const [family, name] = tagParts;
    return (
      <>
        <strong>{family}</strong>: {name}
      </>
    );
  }

  return tag;
};
